export default __webpack_public_path__ + "static/media/photo 18.a42d0645.jpg";